export default {
  manual: 'Ręczne',
  filters: {
    status: 'Status',
    event_type: 'Typ zdarzenia',
  },
  columns: {
    event: 'Zdarzenie',
    status: 'Status',
    attempts: 'Próby',
    last_http_status: 'Ostatni status HTTP',
    created_at: 'Utworzono',
  },
  statuses: {
    pending: 'Oczekujące',
    delivered: 'Dostarczone',
    failed: 'Nieudane',
  },
  buttons: {
    details: 'Szczegóły',
    resend: 'Wyślij ponownie',
  },
  detail: {
    title: 'Szczegóły dostawy',
    event: 'Zdarzenie',
    attempts: 'Próby',
    no_attempts: 'Brak prób.',
    no_response: 'brak odpowiedzi',
    payload: 'Ładunek',
  },
  toasts: {
    load_error: 'Nie udało się wczytać dostaw.',
    resend_error: 'Nie udało się ponownie wysłać dostawy.',
    resent: 'Dostawa dodana do kolejki ponownego wysyłania.',
  },
};
